/* eslint-disable  */
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
// Relocated to the Inventory module: renders inside the Inventory layout.
import RenderHirePurchasePage from '../../InventoryModel/RenderInventoryPage'
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { bindActionCreators } from 'redux';
import { productActionCreators } from '../../services/Actions';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../Components/Loader';
import { ToastContainer, toast } from 'react-toastify';
import { FiArrowLeft, FiCheck, FiX, FiPackage, FiImage } from 'react-icons/fi';

function ProductDetailed() {
  const history = useHistory()
  const dispatch = useDispatch()
  const product = history.location.state.product
  const product_id = history.location.state.product_id
  const { GetProductById, ResetProductResponse } = bindActionCreators(productActionCreators, dispatch)
  const ProductDe = useSelector(state => state?.product)
  const { isLoading, product_detailed, response } = ProductDe
  const [selectedImage, setSelectedImage] = useState(0);

  useEffect(() => {
    GetProductById(product_id)
  }, [product_id])

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => {
        ResetProductResponse();
      }, 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => {
        ResetProductResponse();
      }, 1500);
    }
  }, [response?.state]);

  return (
    <RenderHirePurchasePage>
      {isLoading && <Loader />}
      <div className='ProductDetailed min-h-screen bg-gray-50 p-4 md:p-6'>
        {/* Back Button */}
        <button
          className="flex items-center gap-2 px-4 py-2 mb-6 bg-white hover:bg-gray-100 text-black font-medium rounded-xl border border-gray-200 transition-colors shadow-sm"
          onClick={() => history.goBack()}
        >
          <FiArrowLeft className="w-4 h-4" />
          Back to Products
        </button>

        {/* Main Content Card */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            {/* Image Section */}
            <div className="p-6 bg-gray-50 border-b lg:border-b-0 lg:border-r border-gray-100">
              {/* Main Image */}
              <div className="relative aspect-square bg-white rounded-xl overflow-hidden mb-4 border border-gray-100">
                {product_detailed?.images?.length > 0 ? (
                  <img
                    src={product_detailed?.images[selectedImage]?.url}
                    alt="product"
                    className="w-full h-full object-contain"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <FiPackage className="w-16 h-16 text-gray-300" />
                  </div>
                )}
              </div>

              {/* Thumbnail Gallery */}
              {product_detailed?.images?.length > 1 && (
                <div className="flex gap-2 overflow-x-auto pb-2">
                  {product_detailed?.images?.map((img, index) => (
                    <button
                      key={index}
                      onClick={() => setSelectedImage(index)}
                      className={`flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden border-2 transition-all ${selectedImage === index
                          ? 'border-blue-500 ring-2 ring-blue-200'
                          : 'border-gray-200 hover:border-gray-300'
                        }`}
                    >
                      <img
                        src={img?.url}
                        alt={`thumbnail ${index + 1}`}
                        className="w-full h-full object-cover"
                      />
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Info Section */}
            <div className="p-6 lg:p-8">
              {/* Product Title */}
              <h1 className="text-2xl md:text-3xl font-bold text-black mb-3 leading-tight">
                {product_detailed?.product_name || product?.product_name}
              </h1>

              {/* Short Description */}
              <p className="text-gray-600 mb-4 leading-relaxed">
                {product_detailed?.short_description}
              </p>

              {/* Stock Status */}
              <div className="mb-6">
                {product_detailed?.quantity > 0 ? (
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-medium">
                    <FiCheck className="w-4 h-4" />
                    Available In Stock ({product_detailed?.quantity} units)
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-red-100 text-red-700 rounded-full text-sm font-medium">
                    <FiX className="w-4 h-4" />
                    Out of Stock
                  </span>
                )}
              </div>

              {/* Price */}
              <div className="flex items-baseline gap-3 mb-6 pb-6 border-b border-gray-100">
                <span className="text-3xl font-bold text-emerald-600">
                  &#8373;{product_detailed?.new_price}
                </span>
                {product_detailed?.old_price && (
                  <span className="text-lg text-gray-400 line-through">
                    &#8373;{product_detailed?.old_price}
                  </span>
                )}
                {product_detailed?.old_price && product_detailed?.new_price && (
                  <span className="px-2 py-1 bg-red-100 text-red-600 text-xs font-semibold rounded-full">
                    {Math.round(((product_detailed?.old_price - product_detailed?.new_price) / product_detailed?.old_price) * 100)}% OFF
                  </span>
                )}
              </div>

              {/* Sizes */}
              {product_detailed?.sizes?.length > 0 && (
                <div className="mb-6">
                  <h3 className="text-sm font-semibold text-black mb-3 uppercase tracking-wide">
                    Available Sizes
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {product_detailed?.sizes?.map((size, index) => (
                      <span
                        key={index}
                        className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-black text-sm font-medium rounded-lg cursor-pointer transition-colors border border-gray-200"
                      >
                        {size}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* Colors */}
              {product_detailed?.colors?.length > 0 && (
                <div className="mb-6">
                  <h3 className="text-sm font-semibold text-black mb-3 uppercase tracking-wide">
                    Available Colors
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {product_detailed?.colors?.map((color, index) => (
                      <div
                        key={index}
                        className="flex items-center gap-2 px-3 py-2 bg-gray-50 rounded-lg border border-gray-200"
                      >
                        <span
                          className="w-5 h-5 rounded-full border border-gray-300 shadow-inner"
                          style={{ backgroundColor: color }}
                        />
                        <span className="text-sm text-black capitalize">{color}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Category & Supplier Info */}
              <div className="grid grid-cols-2 gap-4 pt-6 border-t border-gray-100">
                {product_detailed?.category?.name && (
                  <div>
                    <span className="text-xs text-gray-500 uppercase tracking-wide">Category</span>
                    <p className="text-black font-medium">{product_detailed?.category?.name}</p>
                  </div>
                )}
                {product_detailed?.supplier?.name && (
                  <div>
                    <span className="text-xs text-gray-500 uppercase tracking-wide">Supplier</span>
                    <p className="text-black font-medium">{product_detailed?.supplier?.name}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Description Section */}
        {product_detailed?.description && (
          <div className="mt-6 bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-100 bg-gray-50">
              <h2 className="text-lg font-bold text-black">Product Description</h2>
            </div>
            <div className="p-6">
              <div
                className="prose prose-gray max-w-none text-black leading-relaxed"
                dangerouslySetInnerHTML={{ __html: product_detailed?.description }}
              />
            </div>
          </div>
        )}

        {/* Product Images Gallery */}
        {product_detailed?.images?.length > 0 && (
          <div className="mt-6 bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-100 bg-gray-50 flex items-center gap-2">
              <FiImage className="w-5 h-5 text-gray-500" />
              <h2 className="text-lg font-bold text-black">Product Gallery</h2>
              <span className="ml-auto text-sm text-gray-500">
                {product_detailed?.images?.length} images
              </span>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {product_detailed?.images?.map((img, index) => (
                  <div
                    key={index}
                    className="aspect-square bg-gray-50 rounded-xl overflow-hidden border border-gray-100 hover:border-blue-300 transition-colors cursor-pointer group"
                    onClick={() => setSelectedImage(index)}
                  >
                    <img
                      src={img?.url}
                      alt={`product ${index + 1}`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastContainer autoClose={3000} />
    </RenderHirePurchasePage>
  )
}

export default ProductDetailed